export const MFA_CONS = {
  title: 'Let\'s verify it\'s you',
  description: 'We sent a one-time code to your phone or email.',
  cancel: 'Cancel'
};

export const MFA_ERROR_MODAL = {
  title: 'You\'ve been locked out',
  description: 'There were too many incorrect attempts. You\'ll need to wait 30 minutes to try again.',
  unlock_account: 'Unlock account',
  forgot_username: 'Forgot username'
};

export const errorPageContent_UR = {
  mfaTitle: 'The wrong code was entered too many times',
  mnoTitle: 'We couldn\'t verify that number',
  mfaDescription: 'For your security, you\'ll have to wait 30 minutes to try again. If you need help, please call us.',
  TTY: 'TTY: 711',
  restart: 'Restart registration',
  restart2: 'Restart',
  mnoH1: 'We need you to try a different number',
  mnoDescription: (phoneNumber = 'that phone number') => {
    return `We couldn't verify your identity using ${phoneNumber}.`;
  },
  mnoDescription2: 'Check the number and try again. Or try a different mobile number on the next page.',
  linkText: 'Continue'
};

// Translation configuration for mfa page
export const MFA_TRANSLATION_CONFIG = [
  { key: 'MFA_CONS', value: MFA_CONS, message: JSON.stringify(MFA_CONS) },
  { key: 'MFA_ERROR_MODAL', value: MFA_ERROR_MODAL, message: JSON.stringify(MFA_ERROR_MODAL) },
  {
    key: 'errorPageContent_UR',
    value: JSON.stringify(errorPageContent_UR),
    message: JSON.stringify(errorPageContent_UR)
  }
];

// Helper function to process translated items
export const processMfaTranslations = (translatedItems: any) => {
  if (!translatedItems || Object.keys(translatedItems).length === 0) {
    translatedItems = {};
  }

  const parseObject = (fallback: any) => {
    const parsed = translatedItems[JSON.stringify(fallback)];
    if (parsed) {
      try {
        return typeof parsed === 'string' ? JSON.parse(parsed) : parsed;
      } catch {
        return fallback;
      }
    }
    return fallback;
  };

  return {
    MFA_CONS: parseObject(MFA_CONS),
    MFA_ERROR_MODAL: parseObject(MFA_ERROR_MODAL),
    errorPageContent_UR: parseObject(errorPageContent_UR)
  };
};
